"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleBox = void 0;
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _LazyImage = require("../LazyImage");
var _constants = require("./constants");
var _getLinkLabel = require("./getLinkLabel");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component for displaying preview of an article and being link to it.
 * Must have `introText`, `link.relativeUrl`, `title` and `image.url` specified. Otherwise component returns `null`.
 */
const ArticleBox = ({
  labelRead,
  labelWatch,
  categoryTitle,
  className,
  image,
  introText,
  isVideoArticle,
  link,
  title
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    palette
  } = (0, _mui.useTheme)();
  const {
    relativeUrl
  } = link ?? {};
  const {
    alt,
    url
  } = image ?? {};
  if (!introText || !relativeUrl || !title || !url) {
    return null;
  }
  const imagesVariants = {
    url,
    backgroundColor: palette.grey[100],
    imageFormat: 'WebP',
    imageSizeMultiplier: 2,
    params: [{
      width: _constants.ARTICLE_BOX_DESKTOP_WIDTH,
      quality: 85
    }]
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.ARTICLE_BOX),
    href: relativeUrl,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LazyImage.LazyImage, {
        alt: alt ?? url,
        sizes: `${_constants.ARTICLE_BOX_DESKTOP_WIDTH}px`,
        srcSet: (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants))
      })
    }), categoryTitle ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Category, {
      variant: "caption",
      children: categoryTitle
    }) : undefined, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
      variant: "subtitle1",
      component: "p",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Intro, {
      children: introText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
      mt: "auto",
      children: (0, _getLinkLabel.getLinkLabel)({
        labelRead,
        labelWatch,
        isVideoArticle,
        link
      })
    })]
  });
};
exports.ArticleBox = ArticleBox;
//# sourceMappingURL=ArticleBox.js.map